import {Routes} from "@angular/router";
import {WebapiComponent} from "./app/webapi/webapi.component";
import {MsalGuard} from "@azure/msal-angular";
import {ProfileComponent} from "./app/profile/profile.component";
import {customerIdAuthGuard} from "./app/auth/auth-guard/customer-auth-guard";
import {userManagementAuthGuard} from "./app/auth/auth-guard/user-management-auth-guard";
import {webappAccessGuard} from "./app/auth/auth-guard/webapp-access-guard";
import {addinAccessGuard} from "./app/auth/auth-guard/addin-access-guard";
import {addinLandingGuard} from "./app/auth/auth-guard/addin-landing-guard";
import {DashboardComponent} from "./app/dashboard/feature/dashboard/dashboard.component";

export const APP_ROUTES: Routes = [
  {
    path: 'webapi',
    component: WebapiComponent,
    // The profile component is protected with MSAL Guard.
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    // The profile component is protected with MSAL Guard.
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'library',
    loadChildren: () =>
      import('./app/global-config/global-config-routes')
        .then((m) => m.GLOBAL_CONFIG_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'build-kit',
    title: 'Build Kits',
    loadChildren: () =>
      import('./app/build-kit/build-kit-routes')
        .then((m) => m.BUILD_KIT_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'cad-data',
    title: 'CAD Data',
    loadChildren: () =>
      import('./app/cad-model-upload/cad-model-routes')
        .then((m) => m.CAD_MODEL_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'drawings',
    title: 'Drawings',
    loadChildren: () =>
      import('./app/drawing/drawing-routes')
        .then((m) => m.DRAWING_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'reports',
    title: 'Reports',
    loadChildren: () =>
      import('./app/report/report-routes')
        .then((m) => m.REPORT_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'add-in',
    title: 'Add-in',
    loadChildren: () =>
      import('./app/add-in/add-in-routes')
        .then((m) => m.ADD_IN_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, addinAccessGuard]
  },
  {
    path: 'projects',
    title: 'Projects',
    loadChildren: () =>
      import('./app/project/project-routes')
        .then((m) => m.PROJECT_ROUTES
        ),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: 'admin',
    title: 'Admin',
    loadChildren: () =>
      import('./app/admin/admin-routes')
        .then((m) => m.ADMIN_ROUTES
        ),
    canActivate: [MsalGuard]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./app/auth/auth-routes')
        .then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'file-meta-data',
    loadChildren: () =>
      import('./app/blob-file/blob-file-routes')
        .then((m) => m.BLOB_FILE_ROUTES),
  },
  {
    path: 'user-management',
    title: 'User Management',
    loadChildren: () =>
      import('./app/user-management/user-management-routes')
        .then((m) => m.USER_MANAGEMENT_ROUTES),
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard, userManagementAuthGuard]
  },
  {
    path: 'redirect',
    component: DashboardComponent,
    canActivate: [MsalGuard, customerIdAuthGuard, webappAccessGuard]
  },
  {
    path: '',
    title: 'Steelworks',
    loadChildren: () =>
      import('./app/dashboard/dashboard-routes')
        .then((m) => m.DASHBOARD_ROUTES),
      canActivate: [MsalGuard, customerIdAuthGuard, addinLandingGuard, webappAccessGuard]
  },
];
